import React from 'react';
import { useTranslation } from 'react-i18next';

export function ZodiacCrushMapSummary({ worldCount, levelCount }) {
  const { t } = useTranslation('zodiacCrush');

  return (
    <>
      {t('starMap')} · {t('worldCount', { count: worldCount })} · {t('levelCount', { count: levelCount })}
    </>
  );
}

export function ZodiacCrushWorldProgressSummary({
  totalWorldStars,
  worldMaxStars,
  levelCount,
  percent,
  titleStyle,
  titleClassName,
  statsStyle,
  statsClassName,
  percentStyle,
}) {
  const { t } = useTranslation('zodiacCrush');

  return (
    <>
      <div style={titleStyle} className={titleClassName}>{t('worldProgressLabel')}</div>
      <div style={statsStyle} className={statsClassName}>
        <span>⭐ {totalWorldStars}/{worldMaxStars}</span>
        <span>📍 {t('levelCount', { count: levelCount })}</span>
        <span style={percentStyle}>{percent}%</span>
      </div>
    </>
  );
}
